import React, { useState, useContext } from "react";
// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FacilitiesApi from "../../../../Classes/API/Administration/FacilitiesApi";
import CreateFacilityTypeReq2 from "../../../../Classes/Models/Requests/Administration/CreateFacilityTypeReq";
import AsyncSelect from "react-select/async";
import { LanguageContext } from "App";
const AddFacilityTypeToSession = ({ Session, AddToSession, setIsLoaded }) => {
  const { translations } = useContext(LanguageContext);
  const [TypesSearch, setTypesSearch] = useState();
  const [TypeId, setTypeId] = useState("");
  const [Qty, setQty] = useState("");

  const GetFacilityTypes = async () => {
    let searchReq = new CreateFacilityTypeReq2();

    searchReq.TypeName = TypesSearch;
    searchReq.Description = TypesSearch;
    searchReq.Category = TypesSearch;

    let res = await FacilitiesApi.SearchFacilityTypes(searchReq);

    if (res.status == "Success") {
      // setTypes(res.data.list)
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.id, label: item.typeName });
      });

      return optionsArr;
    }
  };

  return (
    <MDBox
      display="flex"
      justifyContent="space-between"
      py={1}
      pr={2}
      sx={{
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      {" "}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MDTypography
          variant="button"
          fontWeight="bold"
          textTransform="capitalize"
          className="ml-2 mb-2"
        >
          {translations.sessionPgSessionsAddFacilityTypes}: &nbsp;
        </MDTypography>

        <MDTypography variant="button" fontWeight="regular" color="text" className="mx-2 mb-2">
          <AsyncSelect
            isClearable={true}
            styles={{
              container: (provided) => ({
                ...provided,
                width: "150px",
              }),
              menu: (provided) => ({
                ...provided,
                width: "150px",
              }),
            }}
            loadOptions={GetFacilityTypes}
            onInputChange={setTypesSearch}
            onChange={(e) => setTypeId(e ? e.value : "")}
          />
        </MDTypography>
      </div>
      <div style={{ display: "flex" }}>
        <MDTypography variant="button" fontWeight="regular" color="text" className="mx-2">
          <MDInput
            onChange={(e) => setQty(e.target.value)}
            className={translations.setlang === "ar" ? "rtl-label" : ""}
            label={translations.sessionPgSessionsQuantity}
          ></MDInput>
        </MDTypography>
        <MDTypography
          variant="button"
          fontWeight="regular"
          color="text"
          sx={{ width: { sm: "100px" } }}
        >
          <button onClick={() => AddToSession(TypeId, Qty)} className="btn btn-success">
            +
          </button>
        </MDTypography>
      </div>
    </MDBox>
  );
};

export default AddFacilityTypeToSession;
